import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3004';

function CheckoutForm({ modId }) {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isPaymentReady, setIsPaymentReady] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      setMessage('Payment system is still loading. Please wait a moment.');
      return;
    }

    setIsLoading(true);
    setMessage(null);

    try {
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        redirect: 'if_required',
        confirmParams: {
          return_url: window.location.origin + '/success',
        },
      });

      if (error) {
        setMessage(error.message);
        setIsLoading(false);
      } else if (paymentIntent && paymentIntent.status === 'succeeded') {
        // Get download info from backend
        try {
          const response = await axios.post(`${API_URL}/api/confirm-purchase`, {
            paymentIntentId: paymentIntent.id,
          });

          // Navigate to success page with download info
          navigate('/success', {
            state: {
              downloadInfo: response.data.downloadInfo,
              modName: response.data.modName,
              purchaseId: response.data.purchaseId,
            },
          });
        } catch (err) {
          setMessage('Payment succeeded but failed to retrieve download info. Please contact support.');
          setIsLoading(false);
        }
      } else {
        setMessage('Unexpected payment status. Please contact support.');
        setIsLoading(false);
      }
    } catch (err) {
      setMessage(err.message || 'An unexpected error occurred.');
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <PaymentElement
        onReady={() => setIsPaymentReady(true)}
        onLoadError={(error) => setMessage('Payment form failed to load. Please refresh the page.')}
      />

      {message && (
        <div className="text-red-400 text-sm bg-red-500/10 border-l-4 border-red-500 rounded-r p-3 font-mono">
          {message}
        </div>
      )}

      <button
        disabled={isLoading || !stripe || !elements || !isPaymentReady}
        className="w-full h-12 bg-green-500 hover:bg-white disabled:bg-gray-600 disabled:cursor-not-allowed text-black font-bold uppercase tracking-widest transition-all shadow-[0_0_15px_rgba(34,197,94,0.3)] hover:shadow-[0_0_25px_#00ff41]"
      >
        {isLoading ? (
          <span className="flex items-center justify-center gap-2 font-mono">
            <span className="material-symbols-outlined animate-spin">progress_activity</span>
            PROCESSING...
          </span>
        ) : !isPaymentReady ? (
          <span className="flex items-center justify-center gap-2 font-mono">
            <span className="material-symbols-outlined animate-spin">progress_activity</span>
            LOADING...
          </span>
        ) : (
          'COMPLETE PURCHASE'
        )}
      </button>
    </form>
  );
}

export default CheckoutForm;
